<div class="form-floating">
    <input [type]="type" class="form-control" [id]="'floating-label-' + id" [placeholder]="placeholder"
        [(ngModel)]="ngModelIn" (change)="ngModelInChange.emit($event.target.value)"
        (change)="onChange.emit($event.target.value)">
    <label [for]="'floating-label-' + id">{{label}}</label>
</div>